/**
 * @name 全新的打点接口服务
 * 不兼容旧版本打点库，基于完全新版的打点规范。
 * 语雀地址：https://yuque.antfin-inc.com/dlt/portal/nsg989
 *
 * @constructor 构造函数将绑定所有具有以下特征的元素，然后在元素被操作后将其上的对应属性内容上报。
 *
 * 前端打点上传字段
 * action: 必传,打点的具体动作
 * ag_ct: 可以为空,打点的类型，如点击、下载、曝光
 * ag_module: 必传，页面标识，每个页面的标识应该是唯一
 * ag_url: 不用填写，自动获取，当前页面的url地址
 * ag_field: 可以为空 参数类型，如gameid、infoid
 * ag_value: 可以为空 配合ag_field一起使用，参数具体的值
 * ag_extend: 可以为空，扩展参数，由产运定义
 * ag_a1: 可以为空,预留字段
 * ag_a2: 可以为空,预留字段
 * ag_a3: 可以为空,预留字段
 * ag_a4: 可以为空,预留字段
 * ag_a5: 可以为空,预留字段
 * ag_a6: 可以为空,预留字段
 * @绑定在dom的点击上报
 * @example 1 => <div ag-click="action:action;XXX:XXX;XXX2:XXX2;"></div> <可自定义属性内容，推荐使用>
 * ag-click="ag_module:xxxx;ag_ct:click;action:xxxxx;ag_field:xxxx;ag_value:xxxxx;ag_extend:xxxxx;ag_a1:xxxxx;ag_a2:xxxxx;ag_a3:xxxxx;ag_a4:xxxxx;ag_a5:xxxxx;ag_a6:xxxxx"
 *
 * @绑定在dom的曝光上报
 * @example 1 => <div ag-expose="action:action;XXX:XXX;XXX2:XXX2;"></div>
 * ag-expose="ag_module:xxxx;ag_ct:expose;action:xxxxx;ag_field:xxxx;ag_value:xxxxx;ag_extend:xxxxx;ag_a1:xxxxx;ag_a2:xxxxx;ag_a3:xxxxx;ag_a4:xxxxx;ag_a5:xxxxx;ag_a6:xxxxx"
 *
 * @method StatPortal 上报门户服务器，并经过清洗后进入门户清洗中间表
 * @param {action:'',...} 将属性上报到门户的发行统计接口 /stat/report/new/。
 * 
 * 20210329新增
 * 
 * @绑定在dom的下载上报
 * @example 1 => <div ag-down="action:action;XXX:XXX;XXX2:XXX2;"></div> <可自定义属性内容，推荐使用>
 * ag-down="ag_module:xxxx;ag_ct:down;action:xxxxx;ag_field:xxxx;ag_value:xxxxx;ag_extend:xxxxx;ag_a1:xxxxx;ag_a2:xxxxx;ag_a3:xxxxx;ag_a4:xxxxx;ag_a5:xxxxx;ag_a6:xxxxx"
 * 
 * @绑定在dom的高速下载上报
 * @example 1 => <div ag-qdown="action:action;XXX:XXX;XXX2:XXX2;"></div> <可自定义属性内容，推荐使用>
 * ag-qdown="ag_module:xxxx;ag_ct:quick_down;action:xxxxx;ag_field:xxxx;ag_value:xxxxx;ag_extend:xxxxx;ag_a1:xxxxx;ag_a2:xxxxx;ag_a3:xxxxx;ag_a4:xxxxx;ag_a5:xxxxx;ag_a6:xxxxx"
 * 由于原来的方法中的绑定dom方式会增大html内容。由于现在想减少html内容量，所以做打点优化
 * 
 * 
 * ag_ct data类型仅支持customStatPortal方法使用。用于技术相关打点！！！
 * ag_ct data类型仅支持customStatPortal方法使用。用于技术相关打点！！！
 * ag_ct data类型仅支持customStatPortal方法使用。用于技术相关打点！！！
 */

function debounce(fn, delay = 1000) {
  let cb = fn;
  let timerId = null;

  function debounced() {
    let ctx = this;
    let args = arguments;
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      cb.apply(ctx, args);
    }, delay);
  }
  return debounced;
}

function throttle(fn, delay = 1000) {
  let cb = fn;
  let timerId = null;
  let firstInvoke = true;
  function throttled() {
    let ctx = this;
    let args = arguments;

    if (firstInvoke) {
      cb.apply(ctx, args);
      firstInvoke = false;
      return;
    }

    if (timerId) {
      return;
    }

    timerId = setTimeout(function() {
      clearTimeout(timerId);
      timerId = null;

      cb.apply(ctx, args);
    }, delay);
  }
  return throttled;
}

function isArray(it) {
  return Object.prototype.toString.call(it) === '[object Array]';
}

class AgStat {
  /**
   * @param {String} page ag_module基于page初始化
   * @param {Object} options 初始化时，可以传入当前页面的基础打点信息，主要为ag_field、ag_value这两个字段的，如果存在其他额外值作为公共常量的打点，也可以补充进去
   */
  constructor(page, options, opts) {
    if (!page) {
      console.error('[constructor]初始化时，页面打点基础页面别称不能为空');
      return;
    }
    this.page = page;
    this.basestatinfo = {
      ag_module: page + '_index',
      ...options,
    };
    this.scrollListener = $(window);
    this.ExplorePortalEleMap = {};
    this.initBindElementClick();
    this.initBindElementExplore();
    this.sendPortalAdUrl = '/stat/report/new/';
    // key白名单 对应的打点说明 https://yuque.antfin-inc.com/dlt/portal/tfb09p#xgS4
    // "ag_"开头和"action"均为新版打点，'zzjs', 'zxbj', 'submit_remark', 'audit_person'为资讯专用旧打点
    this.KEY_WHITELIST = ['ag_module', 'ag_ct', 'action', 'ag_field', 'ag_value', 'ag_extend', 'ag_a1', 'ag_a2', 'ag_a3', 'ag_a4', 'ag_a5', 'ag_a6', 'ag_a7', 'ag_a8', 'ag_a9', 'ag_a10', 'ag_a11', 'ag_a12', 'ag_a13', 'ag_a14', 'zzjs', 'zxbj', 'submit_remark', 'audit_person'];
    this.TYPES = ['expose', 'click', 'quick_down', 'down', 'data'];
    this.pageStartTime = Date.now();
    this.hiddenTime = 0; // 隐藏累计时长
    this.hiddenStartTime = 0; // 每次隐藏开始的时间
    this.init(opts);
  }

  set scrollDOM($DOM) {
    this.scrollListener = typeof $DOM === 'string' ? $($DOM) : $DOM;
    this.bindScrollEvent();
  }

  init(opts) {
    window.GLOBAL_AgStat = this;
    window.addEventListener('load', () => {
      if (opts && opts.CloseStatTime) {
        console.log('[关闭页面统计] heartStat');
        return;
      }
      this.pageStartTime = Date.now();
      setTimeout(() => {
        const performance = window.performance || window.msPerformance || window.webkitPerformance;
        if (performance) {
          const timing = performance.timing;
          this.customStatPortal({
            ag_extend: 'perf',
            ag_a1: timing.responseEnd - timing.fetchStart, // 首次渲染时间（白屏时间
            ag_a2: timing.domInteractive - timing.fetchStart, // 首次可交互时间
            ag_a3: timing.domContentLoadedEventEnd - timing.fetchStart, // HTML加载完成时间，即DOM Ready时间。
            ag_a4: timing.loadEventStart - timing.fetchStart, // 页面完全加载时间
            ag_a5: timing.domainLookupEnd - timing.domainLookupStart, // DNS查询耗时
            ag_a6: timing.connectEnd - timing.connectStart, // TCP连接耗时
            ag_a7: timing.responseStart - timing.requestStart, // 请求响应耗时
            ag_a8: timing.responseEnd - timing.responseStart, // 内容传输耗时
            ag_a9: timing.domInteractive - timing.responseEnd, // DOM解析耗时
            ag_a10: timing.loadEventStart - timing.domContentLoadedEventEnd, // 资源加载耗时
          }, 'data');
        } else {
          this.customStatPortal({
            ag_extend: 'noperf'
          }, 'data');
        }
      }, 0);
      let num = 0;
      const heartStat = () => {
        this.customStatPortal({
          ag_extend: 'staytime',
          ag_a1: ++num,
        }, 'data');
      }
      let timer = setInterval(heartStat, 15000);
      window.addEventListener('visibilitychange', (e) => {
        if (document.visibilityState && document.visibilityState === 'hidden') {
          this.hiddenStartTime = Date.now();
          // console.log('hidden===>', this.hiddenStartTime);
          clearInterval(timer);
        } else if (document.visibilityState && document.visibilityState === 'visible') {
          if (this.hiddenStartTime > 0) {
            this.hiddenTime = Date.now() - this.hiddenStartTime;
            // console.log('visible===>', this.hiddenTime);
            timer = setInterval(heartStat, 15000);
          }
        }
      });
    }, false);
  }

  handleStat(stat, type) {
    let reportStat = {
      ag_ct: type,
      ...this.basestatinfo,
    };
    if (type === 'expose' || type === 'click') {
      reportStat.action = `${this.page}_${type}`;
    } else if (type === 'quick_down' || type === 'down') {
      reportStat.action = `${this.page}_down`;
    } else if (type === 'data') {
      reportStat.action = `${this.page}_data`;
    }
    if (typeof stat === 'string') {
      const array = stat.split(';');
      array.forEach(element => {
        const tempInfo = element.split(':');
        reportStat[ tempInfo[ 0 ] ] = tempInfo[ 1 ];
      });
    } else if (typeof stat === 'object'){
      reportStat = {
        ...reportStat,
        ...stat,
      }
    }
    return reportStat;
  }

  /**
   * 自定义打点
   * @param {Object} stat 
   * @param {String} type 
   * @returns 
   */
  customStatPortal(stat, type) {
    if (Object.prototype.toString.call(stat) !== '[object Object]') {
      console.error('[customStatPortal]中stat仅支持对象类型');
      return;
    }
    const hasType = this.TYPES.find(v => v === type);
    if (!hasType) {
      console.error('[customStatPortal]中type必须为expose、click、quick_down、down、data中的一种');
      return;
    }
    const statInfo = this.handleStat(stat, type);
    this.StatPortal(statInfo);
  }

  StatPortal(statInfo) {
    if (!statInfo.action) {
      console.warn('[SendToPortal]:action不能为空');
      return;
    }

    this.SendToPortal({
      ...statInfo,
      ag_url: window.location.pathname + window.location.search,
      ag_a14: Date.now() - this.pageStartTime - this.hiddenTime, // 用户操作停留时长
    });
    // console.log('sp===>', Date.now() - this.pageStartTime - this.hiddenTime);
  }

  StatPortalV2(statInfos) {
    if (this.IsSpider()) return;
    if (typeof $ === 'undefined') {
      console.warn('[StatPortalV2]:缺少"$"依赖,ajax上报门户失败');
      return;
    }

    if (!isArray(statInfos)) {
      console.warn('[StatPortalV2]:statInfos必须是数组');
      return;
    }

    let stats = '';
    statInfos.forEach(item => {
      if (!item.action) {
        console.warn('[StatPortalV2]:action不能为空');
        return;
      }
      let temp = '';
      for (let i in item) {
        if (typeof item[i] !== 'undefined') {
          temp += `${i}:${item[i]}` + '`';
        }
      }
      temp += `ag_url:${window.location.pathname + window.location.search}` + '`';
      temp += `ag_a14:${Date.now() - this.pageStartTime - this.hiddenTime}` + '`';
      stats += `${temp.substring(0, temp.length - 1)}####`;
    });

    const data = {
      logs: stats.substring(0, stats.length - 4),
    };

    window.setTimeout(() => {
      $.ajax({
        type: 'POST',
        url: '/stat/report/list/',
        data,
        timeout: 4000,
        success: function (data) {
        },
        error: function (err) {
        }
      });
    }, 0);
  }

  // getElementTop(element) {
  //   var actualTop = element.offsetTop;
  //   var current = element.offsetParent;

  //   while (current !== null) {
  //     actualTop += current.offsetTop;
  //     current = current.offsetParent;
  //   }

  //   return actualTop;
  // }

  isElementVisible(element, wrapper) {
    const e = element;
    if (!e || typeof document === 'undefined') {
      return false;
    }

    let wrapperWidth;
    let wrapperHeight;
    let wrapperTop = 0;
    let wrapperLeft = 0;
    wrapper = wrapper || window;
  
    if (wrapper === window) {
      wrapperWidth = window.innerWidth || document.documentElement.clientWidth;
      wrapperHeight = window.innerHeight || document.documentElement.clientHeight;
    } else {
      const wrapperRect = wrapper.getBoundingClientRect();
      wrapperTop = wrapperRect.top;
      wrapperLeft = wrapperRect.left;
      wrapperWidth = wrapperRect.width;
      wrapperHeight = wrapperRect.height;
    }

    const rect = e.getBoundingClientRect();
    const elementTop = rect.top - wrapperTop;
    const elementLeft = rect.left - wrapperLeft;
    const elementWidth = rect.width;
    const elementOffsetHeight = e.offsetHeight;
    const elementOffsetLeft = elementLeft + elementWidth / 2;

    if (rect.width === 0 && rect.height === 0) {
      return false;
    }

    if (elementOffsetLeft < wrapperWidth && elementOffsetLeft >= 0) {
      if (elementTop >= 0) {
        if ((elementTop + 8) < wrapperHeight) {
          return true;
        }
      } else if ((Math.abs(elementTop) + 8) < elementOffsetHeight) {
        return true;
      }
    }
    return false;
  };

  // doExplore() {
  //   // const winHeight = window.innerHeight + this.scrollListener.scrollTop();
  //   const deletePortalIndex = [];
  //   for (const i in this.ExplorePortalEleMap) {
  //     // if (this.ExplorePortalEleMap[ i ].height < winHeight) {
  //     //   deletePortalIndex.push(i);
  //     //   this.StatPortal(this.ExplorePortalEleMap[ i ].stat);
  //     // }
  //     if (this.isElementVisible($(`[ag-expose='${i}']`)[0])) {
  //       deletePortalIndex.push(i);
  //       this.StatPortal(this.ExplorePortalEleMap[ i ].stat);
  //     }
  //   }
  //   deletePortalIndex.forEach(e => {
  //     delete this.ExplorePortalEleMap[ e ];
  //   })
  // }

  // 批量上报
  doExploreV2() {
    const deletePortalIndex = [];
    const batchUploadStats = [];
    for (const i in this.ExplorePortalEleMap) {
      if (this.isElementVisible($(`[ag-expose='${i}']`)[0])) {
        deletePortalIndex.push(i);
        batchUploadStats.push(this.ExplorePortalEleMap[ i ].stat);
      }
    }
    if (batchUploadStats.length > 0) {
      this.StatPortalV2(batchUploadStats);
    }
    deletePortalIndex.forEach(e => {
      delete this.ExplorePortalEleMap[ e ];
    })
  }

  enforceDoExplore(exposeStat) {
    if (this.ExplorePortalEleMap[exposeStat]) {
      this.StatPortal(this.ExplorePortalEleMap[exposeStat].stat);
      delete this.ExplorePortalEleMap[exposeStat];
    }
  }

  initBindElementExplore() {
    window.setTimeout(() => {
      $('[ag-expose]').each((index, e) => {
        // 下了又下模板的打点数据需要过滤
        const isXlyxTemplate = $(e).attr('type') === 'template' ? true : false;
        if (isXlyxTemplate) return;
        const exposeStat = $(e).attr('ag-expose');
        const stat = this.handleStat(exposeStat, 'expose');
        this.ExplorePortalEleMap[exposeStat] = {
          stat,
          // height: this.getElementTop(e),
        };
      });
      this.doExploreV2();
      this.bindScrollEvent();
    }, 1000);
  }

  /**
   * 增加单个元素
   * @param {node｜JQELeme} ele 
   */
  addRecommendExplorePortalEleMap(ele) {
    if (ele.length === 0) {
      return;
    }
    const exposeStat = $(ele).attr('ag-expose'); // 默认给推荐位使用，默认只有一个曝光点
    if (!exposeStat) {
      return;
    }
    setTimeout(() => {
      const stat = this.handleStat(exposeStat, 'expose');
      this.ExplorePortalEleMap[exposeStat] = {
        stat,
        // height: this.getElementTop($(ele)[0]),
      };
    }, 0);
  }

  bindScrollEvent() {
    if (window.location.host.indexOf('www.9game.cn') > -1) {
      this.scrollListener[0].addEventListener('scroll', throttle(e => {
        this.doExploreV2();
      }), false);
    } else {
      this.scrollListener.on('scroll', throttle(e => {
        this.doExploreV2();
      }), false);
    }
  }

  initBindElementClick() {
    this.addCustomClick($('[ag-click],[ag-down],[ag-qdown]'));
  }

  /**
   * 给指定元素绑定click上报打点
   * @param {Array} targets
   */
  addCustomClick(targets) {
    window.setTimeout(() => {
      $(targets).each((i, ele) => {
        $(ele).on('click', debounce(() => {
          const clickTypeStatInfo = $(ele).attr('ag-click');
          const downTypeStatInfo = $(ele).attr('ag-down');
          const qdownTypeStatInfo = $(ele).attr('ag-qdown');
          let type = '';
          let statInfo = '';
          if (clickTypeStatInfo) {
            type = 'click';
            statInfo = clickTypeStatInfo;
          } else if (downTypeStatInfo) {
            type = 'down';
            statInfo = downTypeStatInfo;
          } else if (qdownTypeStatInfo) {
            type = 'quick_down';
            statInfo = qdownTypeStatInfo;
          }
          if (!statInfo) return;
          const stat = this.handleStat(statInfo, type);
          this.StatPortal(stat);
        }));
      });
    }, 0);
  }

  IsSpider() {
    return !!window.navigator.userAgent.toLowerCase().match('spider') || !!window.navigator.userAgent.toLowerCase().match('bot');
  }

  SendToPortal(stat) {
    if (this.IsSpider()) return;
    if (typeof $ === 'undefined') {
      console.warn('[SendToPortal]:缺少"$"依赖,ajax上报门户失败');
      return;
    }

    window.setTimeout(() => {
      $.ajax({
        type: 'POST',
        url: this.sendPortalAdUrl,
        data: stat,
        timeout: 4000,
        success: function (data) {
        },
        error: function (err) {
        }
      });
    }, 0);
  }

  /**
   * 基于传入的参数返回生成好的打点字符串
   * @param {Object} obj 打点对应该数据对象
   * @param {ENUM} type this.TYPES ['expose', 'click', 'quick_down', 'down']
   */
   createPageStat(obj, type) {
    if (typeof obj !== 'object') {
      return;
    }
    obj = {
      ...this.basestatinfo,
      ...obj,
    };
    let stat = '';
    Object.keys(obj).forEach((key, idx) => {
      if (this.KEY_WHITELIST.includes(key)) {
        if (idx == 0) {
          stat += `${key}:${obj[key]}`;
        } else {
          stat += `;${key}:${obj[key]}`;
        }
      }
    });
    if (type === 'expose') {
      return 'ag-expose="' + stat + '"';
    } else if (type === 'click') {
      return 'ag-click="' + stat + '"';
    } else if (type === 'quick_down') {
      return 'ag-qdown="' + stat + '"';
    } else if (type === 'down') {
      return 'ag-down="' + stat + '"';
    }
  }
}

module.exports = AgStat;

// if (window.GLOBAL_AgStat) {
//   module.exports = window.GLOBAL_AgStat;
// } else {
//   module.exports = window.GLOBAL_AgStat = new AgStat();
// }



// WEBPACK FOOTER //
// ./lib/js/public/ag_statv2.js